import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './DistrictEditScreen';
import DistrictEdit from './DistrictEditScreen';
import { StoreState } from 'src/store/reducers';
import { getDistrict, deleteFileDistrict, getFiles } from 'src/store/actions/district-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        district: state.districts.current,
        inProgress: state.districts.inProgress,
        files: state.districts.currentFiles,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id) => dispatch(getDistrict(id)),
        getFiles: (id) => dispatch(getFiles(id)),

        removeFile: (id) => dispatch(deleteFileDistrict(id)),
    };
}

const DistrictEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(DistrictEdit);

export default DistrictEditScreen;
